import { render, staticRenderFns } from "./CollectionFlow.vue?vue&type=template&id=74f2667c&scoped=true"
import script from "./CollectionFlow.vue?vue&type=script&lang=js"
export * from "./CollectionFlow.vue?vue&type=script&lang=js"
import style0 from "./CollectionFlow.vue?vue&type=style&index=0&id=74f2667c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f2667c",
  null
  
)

export default component.exports